import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { mobile, tablet, large } from '~styles/global'
import { useInView } from 'react-intersection-observer'

const GhostSlide = ({ className, i, onChange }) => {

	const [ref, inView] = useInView({threshold: 0.714 })

	useEffect(() => {
		if(inView && onChange) {
			onChange(i)
		}
	}, [inView, onChange])


	return (
		<div ref={ref} className={inView ? 'active' : ''}> 
			<Wrap className={className} large={large}>
				
			</Wrap>
		</div>
	)
}

const Wrap = styled.div`
	height: ${props => props.large ? '70vh' : '100vh'};
`

GhostSlide.propTypes = {
	className: PropTypes.string
}

export default GhostSlide